// Third party dependencies
import { useTranslation } from 'react-i18next';
import { Gap, Heading, Panel, theme } from '@salecycle/ui-component-library';

// Local dependencies
import { ClientLevel } from 'core/types';
import { ClientSelect } from 'components/experimental/ClientSelect';

const { SITE, GROUP, BRAND } = ClientLevel;

export function FileExportClientSelectionArea({ clientId, onClientChange, onLevelChanged, clientLevel }) {
  const { t } = useTranslation('fileExport');

  return (
    <>
      <Gap top={50} />
      <Panel variation="clean" padding={0}>
        <Heading variation="h2" color={theme.vars.color.grey4}>
          {t('clientSelectionArea.heading')}
        </Heading>
        <Gap top={10} />
        <ClientSelect
          groupsEnabled={true}
          brandsEnabled={true}
          level={clientLevel}
          siteId={clientLevel === SITE ? clientId : null}
          brandId={clientLevel === BRAND ? clientId : null}
          groupId={clientLevel === GROUP ? clientId : null}
          onLevelChanged={onLevelChanged}
          onSiteChanged={onClientChange}
          onBrandChanged={onClientChange}
          onGroupChanged={onClientChange}
        />
      </Panel>
    </>
  );
}
